/**
 * Shared badge components for the layout chrome. Pure helpers (formatCount /
 * userInitials) live in `./utils` to keep fast-refresh happy.
 */
import { cn } from '@/lib/utils';

import { formatCount } from './utils';

interface NavBadgeProps {
  count: number | undefined;
  className?: string;
}

/**
 * A small brand pill showing a count. Renders nothing when the count is
 * absent or zero (no badges for empty/unauthenticated states).
 */
export function NavBadge({ count, className }: NavBadgeProps) {
  if (!count || count <= 0) return null;
  return (
    <span
      className={cn(
        'inline-flex h-5 min-w-[1.25rem] items-center justify-center rounded-full bg-brand px-1.5 text-[11px] font-semibold leading-none text-primary-foreground',
        className
      )}
    >
      {formatCount(count)}
    </span>
  );
}

interface DotBadgeProps {
  count: number | undefined;
  className?: string;
}

/**
 * An overlaid badge for icon buttons (top-right corner of a square icon).
 * Renders nothing when empty.
 */
export function DotBadge({ count, className }: DotBadgeProps) {
  if (!count || count <= 0) return null;
  return (
    <span
      className={cn(
        'absolute -right-0.5 -top-0.5 inline-flex h-4 min-w-[1rem] items-center justify-center rounded-full bg-danger px-1 text-[10px] font-semibold leading-none text-white shadow-sm',
        className
      )}
    >
      {formatCount(count)}
    </span>
  );
}
